export default "__VITE_ASSET__DNBwT$Zv__"